import { Button, ExclamationmarkIcon } from '@bp/ui-components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './InvalidationBanner.module.scss';

type InvalidationBannerProps = {
  /** Re-run the check whose result went stale. */
  onRerun: () => void;
  isLoading?: boolean;
};

/** Shown above a check's findings when the plan was edited since the check ran (P2-5). */
export const InvalidationBanner: FC<InvalidationBannerProps> = ({ onRerun, isLoading }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.banner}>
      <ExclamationmarkIcon className='small' color='var(--color-warning)' />
      <div className={styles.text}>{t('findings.stale.text')}</div>
      <Button hierarchy='tertiary' onClick={onRerun} disabled={isLoading}>
        {t('findings.stale.rerun')}
      </Button>
    </div>
  );
};
